import React from 'react'
import Footer from '../../Components/footer';
import { Header } from '../../Components/partial/Header';
import LoginRagister from './LoginRegister'

const LoginRegisterIndex = () => {
  return (
    <>
      
         < Header/>
        
          <LoginRagister/>
      
          <Footer/>
      
    </>
  )
}

export default LoginRegisterIndex;